export default function gestionType(props, error) {
  if (!props && error) {
    return 'is-danger';
  }
  return '';
}
